/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 初期心電図
 */
export type TreatmentInitialEcgEnum =
  (typeof TreatmentInitialEcgEnum)[keyof typeof TreatmentInitialEcgEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentInitialEcgEnum = {
  NORMAL: 'NORMAL',
  VF: 'VF',
  VT: 'VT',
  PEA: 'PEA',
  ASYSTOLE: 'ASYSTOLE',
  OTHER: 'OTHER',
} as const;
